var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center"},[_c('Alert',{attrs:{"title":_vm.LABEL.ERRORI.OPS,"description":_vm.LABEL.ERRORI.NOT_FOUND,"btn":{
      label: _vm.LABEL.ERRORI.BACK_TO_REQUESTS,
      icon: 'arrow-left',
      action: () => this.$router.push({ name: _vm.nameRoutes.RICHIESTE }),
    }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }